// Theme configuration for Manuscript Match
export const theme = {
  colors: {
    background: '#fdfcfb',
    white: '#ffffff',
    textPrimary: '#2d2d2d',
    textSecondary: '#5a5a5a',
    textTertiary: '#9a9a9a',
    primary: '#7a9b7f',
    primaryLight: '#e8ede9',
    primaryDark: '#5a6d5c',
    border: '#e8e3db',
    backgroundAlt: '#f7f5f2',
    error: '#c85a54',
    errorLight: '#f8e8e7',
    success: '#7a9b7f',
    successLight: '#e8f5e9',
    warning: '#e65100',
    warningLight: '#fff3e0',
    info: '#2196f3',
    infoLight: '#e3f2fd',
  },
  fonts: {
    primary: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
    monospace: "'Courier Prime', 'Courier New', monospace",
  },
  borderRadius: {
    small: '8px',
    medium: '10px',
    large: '12px',
    xlarge: '16px',
    pill: '20px',
  },
  spacing: {
    xs: '8px',
    sm: '12px',
    md: '16px',
    lg: '24px',
    xl: '32px',
    xxl: '40px',
    xxxl: '60px',
  },
};
